const constants = {
  OPTION_TRY_GLOTIO: 'OPTION_TRY_GLOTIO',
  OPTION_TRANSLATE_MULTIPLE_LANGUAGES: 'OPTION_TRANSLATE_MULTIPLE_LANGUAGES',
  OPTION_UPDATE_SHOP: 'OPTION_UPDATE_SHOP'
}

export default constants
